export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/680273bf09bfd3a8fc34474ae0d0eb37.svg";